import React, { useEffect, useState } from "react";
import ChatInterface from "./components/Chat/ChatInterface";
import FileUploader from "./components/Documents/FileUploader";
import { useChatStore, useAuthStore } from "./store";
import "./App.css";

function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuthStore();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(username, password);
      onLogin();
    } catch (err) {
      setError(err.response?.status === 401
        ? "Identifiants incorrects."
        : "Connexion impossible. Réessayez.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-panel">
        <img className="login-logo" src="/logo-kinova.png" alt="Logo Kinova" />
        <div className="login-card">
          <div className="login-heading">
            <h1>RDI GraphRAG</h1>
            <p>Connectez-vous à votre espace</p>
            <div className="login-heading__accent" />
          </div>
          <form className="login-form" onSubmit={handleSubmit}>
            <label className="login-field" htmlFor="login-username">
              <span>Identifiant</span>
              <input
                id="login-username"
                autoComplete="username"
                autoFocus
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </label>
            <label className="login-field" htmlFor="login-password">
              <span>Mot de passe</span>
              <input
                id="login-password"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </label>
            {error && <p className="error login-error" role="alert">{error}</p>}
            <div className="login-form__actions">
              <button type="submit" className="btn btn--primary" disabled={loading}>
                {loading ? (
                  <span className="login-submit__loading">
                    <span className="login-spinner" aria-hidden="true" />
                    Connexion…
                  </span>
                ) : "Se connecter"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default function App() {
  const { isAuthenticated, logout } = useAuthStore();
  const [authed, setAuthed] = useState(isAuthenticated);
  const [tab, setTab] = useState("chat");
  const { loadConversations } = useChatStore();

  useEffect(() => {
    if (authed) loadConversations();
  }, [authed]);

  if (!authed) return <Login onLogin={() => setAuthed(true)} />;

  return (
    <div className="app">
      {/* Sidebar navigation */}
      <nav className="sidebar">
        <div className="sidebar__logo">🕸️ GraphRAG</div>
        <button className={`sidebar__item ${tab === "chat" ? "active" : ""}`} onClick={() => setTab("chat")}>
          💬 Chat
        </button>
        <button className={`sidebar__item ${tab === "documents" ? "active" : ""}`} onClick={() => setTab("documents")}>
          📚 Documents
        </button>
        <button className="sidebar__item sidebar__logout" onClick={() => { logout(); setAuthed(false); }}>
          🚪 Déconnexion
        </button>
      </nav>

      {/* Contenu principal */}
      <main className="main-content">
        {tab === "chat" && <ChatInterface />}
        {tab === "documents" && <FileUploader />}
      </main>
    </div>
  );
}
